module.exports = __webpack_public_path__ + "static/media/logo.831755b5.png";